<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

const toDataURL = (url) =>
    fetch(url)
        .then((response) => response.blob())
        .then(
            (blob) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })
        );
export default {
    components: {
        VueCropper,
    },
    data() {
        return {
            imageUrl: "",
            modalTitle: "Profile Cropper",
            cropImg: "",
            updateProfile: false,
            showCropBtn: false,
            cropBtn: false,
        };
    },
    computed: {
        zIndex() {
            if (this.imageUrl !== "") {
                return 0;
            } else {
                return 10;
            }
        },
    },
    methods: {
        setImage(e) {
            const file = e.target.files[0];
            if (file.type.indexOf("image/") === -1) {
                alert("Please select an image file");
                return;
            }
            if (typeof FileReader === "function") {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imageUrl = event.target.result;
                    this.$refs.cropper.replace(event.target.result);
                    this.showCropBtn = true;
                };
                reader.readAsDataURL(file);
            } else {
                alert("Sorry, FileReader API not supported");
            }
        },
        showFileChooser() {
            this.$refs.input.click();
        },
        async cropPicture() {
            let data = JSON.stringify(
                this.$refs.cropper.getCropBoxData(),
                null,
                4
            );
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            let fullImgUrl = '';
            if(this.updateProfile){
                await toDataURL(this.imageUrl).then((dataUrl) => {
                    fullImgUrl = dataUrl;
                });
            }else{
                fullImgUrl = this.imageUrl;
            }
            this.$emit("crop-picture", {
                cropImg: this.dataURLtoFile(this.cropImg, 'fullimage.jpg'),
                fullImg: this.dataURLtoFile(fullImgUrl, 'cropimage.jpg'),
                cropData: data,
            });
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(","),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        startCrop(){
            this.$refs.cropper.destroy();
            this.$refs.cropper.replace(this.imageUrl);
            this.cropBtn = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.cropper.cropper.crop();
                    this.$refs.cropper.setCropBoxData({
                        width: 200,
                        height: 200,
                    });
                },200)
            });
        },
        resetData(){
            this.imageUrl = "";
            this.cropImg = "";
            this.showCropBtn = false;
            this.cropBtn = false;
        }
    },
};
</script>
<template>
    <b-modal
        id="upload-profile"
        :title="modalTitle"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="text-right">
            <button
                type="button"
                class="btn btn-gradient-primary me-1"
                v-if="imageUrl"
                @click="showFileChooser"
            >
                <i class="bx bx-upload"></i> Upload New Image
            </button>
            <button type="button" class="btn btn-gradient-warning" @click="startCrop" v-if="showCropBtn">
              <i class="bx bx-crop"></i> Crop Image
            </button>
        </div>
        <div class="mb-3">
            <input
                ref="input"
                type="file"
                name="image"
                accept="image/*"
                @change="setImage"
            />
        </div>

        <div class="row align-items-center">
            <div :class="{'col-md-12': !cropBtn, 'col-md-8': cropBtn}">
                <div
                    class="position-relative"
                    :class="{ 'preview-button': !imageUrl }"
                >
                    <vue-cropper
                        ref="cropper"
                        :src="imageUrl"
                        alt="Source Image"
                        preview=".preview-lg"
                        :cropBoxResizable="false"
                        dragMode="none"
                        :zoom-on-touch="false"
                        :zoom-on-wheel="false"
                        :zoomable="false"
                        :autoCrop="false"
                    />
                    <div
                        :style="{ 'z-index': zIndex }"
                        class="
                            preview-button
                            position-absolute
                            d-flex
                            align-items-center
                            justify-content-center
                            cursor-pointer
                            border-dashed-img
                        "
                        style="top: 0"
                        v-if="!imageUrl"
                        @click="showFileChooser"
                    >
                        Click Here to Upload Image
                    </div>
                </div>
            </div>
            <div class="col-md-4" v-if="cropBtn">
                <div class="text-center">
                    <h5>Crop Image Preview</h5>
                    <div class="preview-lg"></div>
                </div>
            </div>
        </div>
        <hr />
        <div class="text-right">
            <div class="">
                <button
                    type="button"
                    class="btn btn-success me-1"
                    @click="cropPicture"
                    v-if="imageUrl !== ''"
                >
                    <i class="bx bx-save"></i> Save
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('upload-profile')"
                >
                    Cancel
                </button>
            </div>
        </div>
    </b-modal>
</template>
<style scoped>
input[type="file"] {
    display: none;
}
</style>